import { useQuery, useMutation } from 'react-query';
import {
  getTransaction,
  getByIdAndPostedAt,
  resolveTransactionIssue,
} from '~/api/headTransactions';
import { HeadTransaction } from '~/types/HeadTransaction';
import showErrorMessage from '~/errorsHandler';

export const useGetTransaction = (
  id?: string,
  options?: { enabled?: boolean; staleTime?: number }
) => {
  const { enabled = true, ...restOptions } = options ?? {};
  return useQuery(
    ['headTransactions', id],
    () => getTransaction({ id: id! }).then((res) => res.data),
    {
      enabled: enabled && !!id,
      ...restOptions,
    }
  );
};

export const useGetByIdAndPostedAt = (id?: string, postedAt?: string, enabled?: boolean) => {
  return useQuery(
    ['headTransactions', id],
    () => getByIdAndPostedAt({ id: id!, postedAt: postedAt! }),
    {
      enabled: !!id && !!postedAt && enabled !== false,
    }
  );
};

export const useGetByIdAndPostedAtMutation = (
  id: string,
  postedAt: string,
  onSuccess: (data: HeadTransaction) => void,
  onError: () => void
) => {
  return useMutation(
    ['headTransactions', id, postedAt],
    () => getByIdAndPostedAt({ id: id!, postedAt: postedAt! }),
    {
      onSuccess: onSuccess,
      onError: onError,
    }
  );
};

export const useIssueResolution = (onSuccess: () => void) => {
  return useMutation(
    ({ id, issueId, comment }: { id: string; issueId: string; comment: string }) =>
      resolveTransactionIssue({ id, issueId, comment }),
    {
      onSuccess: () => onSuccess(),
      onError: (error) => {
        showErrorMessage(error);
      },
    }
  );
};
